module.exports = __webpack_public_path__ + "img/expire_box.7e372d5f.png";